var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2084 6.25L32.2917 8.33333H39.5834V12.5H10.4167V8.33333H17.7084L19.7917 6.25H30.2084ZM25.0001 26.2292L29.4167 21.8125L32.3542 24.75L27.9376 29.1667L32.3542 33.5833L29.4167 36.5208L25.0001 32.1042L20.5834 36.5208L17.6459 33.5833L22.0626 29.1667L17.6251 24.75L20.5626 21.8125L25.0001 26.2292ZM12.5001 39.5833C12.5001 41.875 14.3751 43.75 16.6667 43.75H33.3334C35.6251 43.75 37.5001 41.875 37.5001 39.5833V14.5833H12.5001V39.5833ZM33.3334 18.75H16.6667V39.5833H33.3334V18.75Z",
    fill: "#324659"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDelete);
export default __webpack_public_path__ + "static/media/icon_delete.e0773ec55a695b8fd3e75939fce647a0.svg";
export { ForwardRef as ReactComponent };